module.exports = __webpack_public_path__ + "static/media/cover-image-v3.f6619aa5.png";